import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ErrorBoundary, Provider } from '@rollbar/react';
import { DesignProvider, DigitalStoreI18Provider, LocaleProvider, MercadoPagoProvider, StripeProvider, useOfferStore, usePublicKeysStore, useVisitorInfoStore, } from '@systemeio/digital-store-shared';
import { ContactSlugEnum, Toast } from '@systemeio/ui';
import { useWatch } from '@systemeio/util';
import React from 'react';
import { useCalculatePrice } from '../hooks/use-calculate-price';
import { usePublicKeys } from '../hooks/use-public-keys';
import { rollbarConfig } from '../rollbar';
export function CheckoutProviders({ locale, design, offerId, children, calculatePriceProps, }) {
    usePublicKeys(offerId);
    const { contactFields, setContactFields } = useOfferStore();
    const { visitorInfo } = useVisitorInfoStore();
    useWatch(visitorInfo, visitorInfo => {
        if (!visitorInfo)
            return;
        const hasEmptyCountry = Object.prototype.hasOwnProperty.call(contactFields, ContactSlugEnum.Country) &&
            !contactFields[ContactSlugEnum.Country].value;
        if (visitorInfo.country && hasEmptyCountry) {
            setContactFields({
                ...contactFields,
                [ContactSlugEnum.Country]: {
                    ...contactFields[ContactSlugEnum.Country],
                    value: visitorInfo.country,
                },
            });
        }
    });
    const country = contactFields?.[ContactSlugEnum.Country]?.value;
    const taxNumber = contactFields?.[ContactSlugEnum.TaxNumber]?.value;
    const { calculatePrice, isLoading: isLoadingCalculatePrice } = useCalculatePrice({
        ...calculatePriceProps,
        country,
        taxNumber: taxNumber ?? null,
    });
    const { stripeAccountId, mercadoPublicKey } = usePublicKeysStore();
    return (_jsx(React.StrictMode, { children: _jsx(Provider, { config: rollbarConfig, children: _jsx(ErrorBoundary, { children: _jsx(DigitalStoreI18Provider, { locale: locale, children: _jsx(LocaleProvider, { locale: locale, children: _jsx(DesignProvider, { design: design, children: _jsx(StripeProvider, { publishableKey: process.env.STRIPE_KEY, stripeAccountId: stripeAccountId, children: _jsxs(MercadoPagoProvider, { publicKey: mercadoPublicKey ?? undefined, children: [children({
                                            calculatePrice,
                                            isLoadingCalculatePrice,
                                        }), _jsx(Toast, {})] }) }) }) }) }) }) }) }));
}
